module.exports = __webpack_public_path__ + "static/cow-645b897cb68ebc92e8d6a43d6d7fe09d.png";